// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WtMb","toggleWrap":"styles_toggleWrap__2r0Ix","content":"styles_content__5SZLC","selectAreaCode":"styles_selectAreaCode__qLBnx"};